import React from "react";

export default function ProcessHistory({ rows = [] }) {
  return (
    <div className="process-action-modal-v2__history-wrap">
      <table className="process-action-modal-v2__history-table">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Canal</th>
            <th>Resultado</th>
            <th>Número</th>
            <th>Duración</th>
            <th>Observación</th>
            <th>Evidencia</th>
            <th>Estado nuevo</th>
          </tr>
        </thead>
        <tbody>
          {!rows.length ? (
            <tr>
              <td colSpan={8} className="process-action-modal-v2__history-empty">
                Todavía no hay gestiones registradas.
              </td>
            </tr>
          ) : (
            rows.map((item) => (
              <tr key={item.id}>
                <td>{item.fecha || "-"}</td>
                <td>{item.canal || "-"}</td>
                <td>{item.resultado || "-"}</td>
                <td>{item.numeroContactado || "-"}</td>
                <td>{item.duracionSegundos ? `${item.duracionSegundos} seg.` : "-"}</td>
                <td>{item.observacion || "-"}</td>
                <td>{item.evidenciaReferencia || "-"}</td>
                <td>{item.estadoNuevo || "-"}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
